export default __webpack_public_path__ + "static/5 1-1c47ea407f483b7d885d0f520fb620d9.png";